import { useFormContext } from 'react-hook-form';
import { IconButton, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useFullscreenModalControls } from '../../modals/context/modal-context-provider';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { EventPanelFormType } from '@mark43/cad-api';

export function CreateEventKebabMenu(): React.ReactElement {
    const modalControls = useFullscreenModalControls();
    const workspacePanel = useWorkspacePanel();
    const integratedForm = useFormContext<EventPanelFormType>();
    return (
        <Menu>
            <MenuTrigger asChild>
                <IconButton
                    data-testid="other-options-menu"
                    variant="ghost"
                    icon="MoreActions"
                    aria-label="more actions"
                />
            </MenuTrigger>
            <MenuContent>
                <MenuItem
                    onSelect={() => {
                        modalControls.open({
                            type: 'TRANSFER_EVENT_INFO',
                            props: {
                                eventForm: integratedForm,
                                sourceEventPanel: workspacePanel,
                            },
                        });
                    }}
                >
                    Transfer Event Info
                </MenuItem>
            </MenuContent>
        </Menu>
    );
}
